import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import SideBar from "../../other/SideBar";
import NavBar from "../../other/NavBar";
import LoadingModal from "../../../loader/LoadingModal";
import DeleteModal from "../../../deleteModal/DeleteModal";
import {
  GetRawMaterialListURL,
  DeleteRawMaterialURL,
  UpdateRawMaterialStatusURL,
 
} from "../../../assets/api/BaseURL";
import Notification from "../../other/Notification";
import { useToast } from "../../../../context/ToastContext";

const RawMaterial = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [token, setToken] = useState("");
  const [toggleSideBar, setToggleSideBar] = useState(false);
  const [canvas, setCanvas] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [data, setData] = useState([]);
  const [flag, setFlag] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const availableRecordsPerPageOptions = [10, 25, 50, 100];
  const [isLoading, setIsLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [totalPages, setTotalPages] = useState(1);
  const [totalrecords, setTotalRecords] = useState(0);
  const [pageNumbersBatch, setPageNumbersBatch] = useState([]);
  const [searchInput, setSearchInput] = useState("");


  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const calculateStartSerialNumber = () => {
    return (currentPage - 1) * recordsPerPage + 1;
  };

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    setToggleSideBar(!toggleSideBar);
  };

  const handleToggleOffCanvas = (e) => {
    e.preventDefault();
    setCanvas(!canvas);
  };

  const handleAddRawMaterialClick = (e) => {
    e.preventDefault();
    navigate("/add_material");
  };

  // function isWithinAlertPeriod(expiry_date, expiry_alert_before) {
  //   if (expiry_date && expiry_alert_before) {
  //     const expiryDate = new Date(expiry_date);
  //     const today = new Date();
  //     const differenceInDays = Math.ceil(
  //       (expiryDate - today) / (1000 * 60 * 60 * 24)
  //     );
  //     return differenceInDays <= expiry_alert_before;
  //   } else {
  //     return false;
  //   }
  // }

  const handleEditClick = (e, id) => {
    e.preventDefault();
    localStorage.setItem("materialID", id);
    navigate(`/edit_material`);
  };

  const handleDelete = (e, id) => {
    e.preventDefault();
    setDeleteId([id]);
    setShowDeleteModal(!showDeleteModal);
  };

  const handleDeleteRawMaterial = async () => {
    try {
      const response = await axios({
        method: "put",
        url: DeleteRawMaterialURL,
        data: deleteId,
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200 && response.data.message) {
        setFlag(!flag);
        setShowDeleteModal(!showDeleteModal);
        addToast("success", response.data.message);
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        addToast("error", error.response.data.message);
      } else {
        addToast("error", error.message);
      }
      console.log(error);
    }
  };

  const handleStatusToggle = async (e, itemId) => {
    setIsLoading(true);

    const dataU = { id: itemId, status: e.target.checked ? 1 : 0 };

    try {
      const response = await axios({
        method: "put",
        url: UpdateRawMaterialStatusURL,
        data: dataU,
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        setFlag(!flag);
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        addToast("error", error.response.data.message);
      } else {
        addToast("error", error.message);
      }
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/auth");
    }
  }, [navigate]);

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, [token]);

 

  useEffect(() => {
    if (localStorage.getItem("currencySymbol")) {
      setCurrencySymbol(localStorage.getItem("currencySymbol"));
    }
  }, []);

  useEffect(() => {
    if (token) {
      
      getData();
    }
  }, [token, flag, currentPage, recordsPerPage, addToast, searchInput]);
   
  async function getData() {
    const searchTerm = searchInput.toLowerCase();

    setIsLoading(true);
    
    try {
      const response = await axios.get(GetRawMaterialListURL, {
        params: {
          page: currentPage,
          limit: recordsPerPage,
          searchTerm: searchTerm,
        },
        headers: { authorization: `Bearer ${token}` },
      });

      if (response.status === 200 && response.data.data) {
        setData(response.data.data);
        setTotalRecords(response.data.totalRecord);
      } else if (response.status === 200 && response.data.message) {
        setData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        addToast("error", error.response.data.message);
      } else {
        addToast("error", error.message);
      }
      console.log(error);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    if (totalrecords) {
      const totalPages = Math.ceil(totalrecords / recordsPerPage);
      setTotalPages(totalPages);

      if (currentPage > totalPages) {
        setCurrentPage(totalPages);
      } else if (currentPage < 1) {
        setCurrentPage(1);
      }

      const maxPageNumbers = 1;
      let startPage = Math.max(currentPage - maxPageNumbers, 1);
      let endPage = Math.min(currentPage + maxPageNumbers, totalPages);

      if (endPage - startPage + 1 <= maxPageNumbers * 2) {
        if (startPage === 1) {
          endPage = Math.min(
            endPage + (maxPageNumbers * 2 - endPage + startPage - 1),
            totalPages
          );
        } else if (endPage === totalPages) {
          startPage = Math.max(
            startPage - (maxPageNumbers * 2 - endPage + startPage - 1),
            1
          );
        }
      }

      if (currentPage === 1) {
        endPage = Math.min(3, totalPages);
      }

      if (currentPage === totalPages && totalPages >= 3) {
        startPage = Math.max(currentPage - 2, 1);
        endPage = totalPages;
      }

      const batch = Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
      setPageNumbersBatch(batch);
    }
  }, [currentPage, recordsPerPage, totalrecords, totalPages]);

  return (
    <>
      {token && (
        <>
          <div
            className={
              toggleSideBar
                ? "container-scroller sidebar-icon-only"
                : "container-scroller"
            }
          >
            <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
              <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
                 {/* <img src="images/mini-kr-logo.svg" alt="logo" />     */}
                </Link>
                <div className="me-1">
                  <button
                    className={
                      toggleSideBar
                        ? "navbar-toggler navbar-toggler align-self-center"
                        : "navbar-toggler navbar-toggler align-self-center text-white"
                    }
                    type="button"
                    onClick={handleToggleSidebar}
                  >
                    <span className="icon-menu"></span>
                  </button>
                </div>
                <div>
                  <Link to="/fooders_cp">
                    <span className="navbar-brand brand-logo">
                      <img src="images/vyfoo_logo.png" alt="logo" />
                    </span>
                  </Link>
                </div>
              </div>
              <NavBar handleToggle={handleToggleOffCanvas} toggleCanvas={toggleSideBar}/>
            </nav>
            <div className="container-fluid page-body-wrapper px-0">
              <SideBar active="raw_material" toggleCanvas={toggleSideBar} />

              <div className="main-panel">
                <div className="content-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <h3 className="ukhd mb-3">Ingredients</h3>
                      <div className="row flex-grow">
                        <div className="col-12 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body">
                              <div className="d-flex justify-content-between align-items-start">
                                <div className="vsalign">
                                  <h4 className="card-title card-title-dash">
                                    All Ingredients
                                  </h4>
                                </div>
                                <div className="vsalign">
                                  <span
                                    className="btn btn-primary text-white mb-0 me-0"
                                    onClick={handleAddRawMaterialClick}
                                  >
                                    <i className="menu-icon mdi mdi-store vsalign"></i>
                                    Add Ingredient
                                  </span>
                                </div>
                              </div>
                              <div className="table-responsive mt-1">



                                <div className="d-flex justify-content-between align-items-start">
                                  <div className="vsalign">

                                    <label>Show records per page:</label>
                                    <select
                                      value={recordsPerPage}
                                      onChange={(e) =>
                                        setRecordsPerPage(
                                          parseInt(e.target.value)
                                        )
                                      }
                                    >
                                      {availableRecordsPerPageOptions.map(
                                        (option) => (
                                          <option key={option} value={option}>
                                            {option}
                                          </option>
                                        )
                                      )}
                                    </select>

                                  </div>
                                  <div className="vsalign mt-2">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search Here"
                                      value={searchInput}
                                      onChange={(e) =>{
                                         
                                          setSearchInput(e.target.value)
                                        
                                      }
                                        
                                      }
                                    />
                                  </div>
                                </div>






                                <table className="table select-table">
                                  <thead>
                                    <tr>
                                      <th>S.No.</th>
                                      <th>Name</th>
                                      <th>Category</th>
                                      <th>Unit</th>
                                      <th>Purchase Price</th>
                                      {/* <th>Sales Price</th> */}
                                      <th>Status</th>
                                      {/* <th>Expiry Date</th> */}
                                      <th className="text-right">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data.length === 0 ? (
                                      <tr>
                                        <td colSpan="8" className="text-center">
                                          No records found
                                        </td>
                                      </tr>
                                    ) : (
                                      data.map((item, index) => (
                                        <tr key={item.id}>
                                          <td>
                                            {calculateStartSerialNumber() +
                                              index}
                                          </td>
                                          <td>
                                            <h6
                                            // className={
                                            //   isWithinAlertPeriod(
                                            //     item.expiry_date,
                                            //     item.expiry_alert_before
                                            //   )
                                            //     ? "text-danger"
                                            //     : ""
                                            // }
                                            >
                                              {item.material_name}
                                            </h6>
                                          </td>
                                          <td>
                                            <p>{item.category_name}</p>
                                          </td>
                                          <td>
                                            <p>{item.measurement_unit}</p>
                                          </td>
                                          <td>
                                            <p>
                                              {currencySymbol}{" "}
                                              {item.purchase_price}
                                            </p>
                                          </td>
                                          {/* <td>
                                            <p>
                                              {currencySymbol}{" "}
                                              {item.sales_price}
                                            </p>
                                          </td> */}
                                          <td className="togglecss">
                                            <div
                                              className={`button r ${item.status === 1
                                                ? "active"
                                                : ""
                                                }`}
                                              id="button-1"
                                            >
                                              <input
                                                type="checkbox"
                                                className="checkbox"
                                                checked={item.status === 1}
                                                onChange={(e) =>
                                                  handleStatusToggle(e, item.id)
                                                }
                                              />
                                              <div className="knobs"></div>
                                              <div className="layer"></div>
                                            </div>
                                          </td>
                                          {/* <td>
                                            <p>{item.expiry_date}</p>
                                          </td> */}
                                          <td className="text-right pe-0">
                                            <i
                                              className="fs-20 mdi mdi-content-save-edit-outline text-success"
                                              title="Edit"
                                              style={{ cursor: "pointer" }}
                                              onClick={(e) =>
                                                handleEditClick(e, item.id)
                                              }
                                            ></i>
                                            &nbsp;&nbsp;
                                            <i
                                              className="fs-20 mdi mdi-archive text-danger"
                                              title="Delete"
                                              style={{ cursor: "pointer" }}
                                              onClick={(e) =>
                                                handleDelete(e, item.id)
                                              }
                                            ></i>
                                          </td>
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </table>
                              </div>

                              <div className="row">
                                <div className="col-6">
                                  {data.length > 0 && (
                                    <p>
                                      Showing{" "}
                                      {(currentPage - 1) * recordsPerPage + 1}{" "}
                                      to{" "}
                                      {(currentPage - 1) * recordsPerPage +
                                        data.length}{" "}
                                      of {totalrecords} entries
                                    </p>
                                  )}
                                </div>
                                <div className="col-6">
                                  <div className="pagination">
                                    <button
                                      onClick={handlePrevPage}
                                      disabled={currentPage === 1}
                                      className={
                                        currentPage === 1 ? "disabled" : ""
                                      }
                                    >
                                      {`<<`}
                                    </button>
                                    {pageNumbersBatch.map((pageNumber) => (
                                      <button
                                        key={pageNumber}
                                        onClick={() =>
                                          handlePageClick(pageNumber)
                                        }
                                        className={
                                          pageNumber === currentPage
                                            ? "active"
                                            : ""
                                        }
                                      >
                                        {pageNumber}
                                      </button>
                                    ))}
                                    <button
                                      onClick={handleNextPage}
                                      disabled={currentPage === totalPages}
                                      className={
                                        currentPage === totalPages
                                          ? "disabled"
                                          : ""
                                      }
                                    >
                                      {`>>`}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {showDeleteModal && (
            <DeleteModal
              handleModal={setShowDeleteModal}
              handleDelete={handleDeleteRawMaterial}
            />
          )}

          <LoadingModal isLoading={isLoading} />

          <Notification />
        </>
      )}
    </>
  );
};

export default RawMaterial;
